import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

function ProductViewModal({
  item,
  productDetails,
  setProductDetails,
  currency,
}) {
  const displayContent = (image, name) =>
    image ? (
      <img
        src={image}
        alt={name}
        className=" w-10 h-10 rounded-md object-cover "
      />
    ) : (
      <div className="w-10 h-10 bg-slate-400 text-white flex justify-center font-medium items-center rounded-md text-xl">
        {name.charAt(0)}
      </div>
    );

  if (!productDetails) {
    return null;
  }
  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6   ">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => setProductDetails(false)}
            className="cursor-pointer text-black mb-2"
          />
        </div>
        <div className=" grid grid-cols-4 gap-x-4 gap-y-4 flex-wrap ">
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Image</label>
            {displayContent(item.image, item.product_name)}
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Store</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item?.store}</h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Warehouse</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item?.warehouse}</h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Supplier</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item?.supplier}</h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="Manufacturing Date">Category</label>
            <h3 className="bg-gray-300 max-w-48 p-2">
              {item?.category?.cat_name}
            </h3>

            {/* Na here the select */}
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="Manufacturing Date">Subcategory</label>
            <h3 className="bg-gray-300 max-w-48 p-2">
              {item?.subcategory?.sub_cat_name}
            </h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Product Name</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item?.product_name}</h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">SKU</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item?.sku}</h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Barcode</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item?.barcode}</h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Quantity </label>
            <h3 className="bg-gray-300 max-w-48 p-2">
              {item?.available_quantity}
            </h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="store">Price</label>
            <h3 className="bg-gray-300 max-w-48 p-2">
              {currency}
              {item?.price}
            </h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="Manufacturing Date">Manufacturing Date</label>
            <h3 className="bg-gray-300 max-w-48 p-2">
              {item?.manufacturing_date}
            </h3>
          </div>

          <div className="flex flex-col w-full ">
            <label htmlFor="Expiring Date">Expiring Date</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item?.expiring_date}</h3>
          </div>
          <div className="flex flex-col w-full ">
            <label htmlFor="">Product Description</label>
            <h3 className="bg-gray-300 max-w-48 p-2">{item.description}</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductViewModal;
